import * as React from 'react';
import styled, { StyledComponentClass } from 'styled-components';

/** @component */
export const StyledFormGroupDiv = styled.div`
  width: 100%;
  position: relative;
`;